import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'containers/App/actions';
import { Spinner } from 'components/Loading';
import GeneralTaskList from './GeneralTaskList';
import ProjectTaskList from './ProjectTaskList';
import LeadTaskList from './LeadTaskList';

import './style.scss';

const MyTasks = () => {
  const dispatch = useDispatch();
  const tasksInfo = useSelector(state => state.global.tasksInfo);
  const { loginTasks, weddings, leads } = tasksInfo || {};
  const isLoading = !loginTasks || !weddings || !leads;
  const { getGeneralTasks, getProjectTasks, getLeadTasks } = bindActionCreators(actions, dispatch);

  useEffect(() => {
    if(!loginTasks) getGeneralTasks();
  }, [loginTasks]);

  useEffect(() => {
    if(!weddings) getProjectTasks();
  }, [weddings]);

  useEffect(() => {
    if(!leads) getLeadTasks();
  }, [leads]);

  return (
    <div className="notification-center__tab notification-center__tab--my-tasks">
      <div className="notification-menu-my-tasks">
        {loginTasks && <GeneralTaskList data={loginTasks} />}
        {weddings && <ProjectTaskList data={weddings} />}
        {leads && <LeadTaskList data={leads} />}
        {isLoading && (
          <Spinner
            height={10}
            width={3}
            margin={0}
          />
        )}
      </div>
    </div>
  );
};

export default MyTasks;
